import React, { useState } from "react";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Modal,
  Alert,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import newbg from "../assets/Bottom_Artwork.jpg"; // Updated background image
import "./Dashboard.css";
import siemens_logo from "../assets/siemens_logo.svg";

const Register = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [company, setCompany] = useState("");
  const [interest, setInterest] = useState("");
  const [jobprofile, setJobProfile] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post("/apis/user/register", {
        name,
        email,
        mobile,
        company,
        interest,
        jobprofile,
      });
      localStorage.clear();
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      navigate(`/rules`);
    } catch (error) {
      if (error.response && error.response.data) {
        setErrorMessage(
          error.response.data.message ||
            "Registration failed. Please try again."
        );
      } else {
        setErrorMessage("An unexpected error occurred. Please try again.");
      }
      setShowModal(true);
    }
  };

  return (
    <div
      style={{
        backgroundImage: `url(${newbg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        //display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <Container>
        <div style={{ position: "absolute", top: "20px", left: "30px" }}>
          {/*<h2 style={{ fontSize: "2.9rem", fontWeight: "bold", color: "#fff" }}>
            COACT
          </h2>*/}          
           <img
            src={siemens_logo}
            alt="logo"
            style={{ width: "150px", height: "80px" }}
          />  
        </div>
        <Row className="justify-content-center">
          <Col md={8}>
            <div
              style={{
                backgroundImage:
                  "linear-gradient(to bottom,rgba(0, 135, 190, 0.6), rgba(0, 0, 40, 0.8))", // Adjust the last value (alpha) for transparency
                padding: "30px",
                borderRadius: "10px",
                backdropFilter: "blur(0px)", // Frosted effect
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", // Soft depth effect
                marginTop: "60px",
                // backgroundColor: "transparent",
              }}
            >
              <h3
                style={{
                  color: "#ffffff",
                  marginBottom: "60px",
                  textAlign: "left",
                }}
              >
                Register to Play
              </h3>
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={12}>
                    <Form.Group className="mb-3">
<Form.Control
  type="text"
  placeholder="Employee Name"
  value={name}
  onChange={(e) => setName(e.target.value.replace(/^\s+/, ""))} // no leading spaces
  required
  style={{
    background: "#ffffff",
    borderRadius: "8px",
    marginBottom: "30px",
  }}
/>

                    </Form.Group>
                    {/*<Form.Group className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Contact No."
                        value={mobile}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d*$/.test(value)) setMobile(value);
                        }}
                        required
                        style={{
                          background: "#ffffff",
                          borderRadius: "8px",
                          marginBottom: "30px",
                        }}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Select
                        value={interest}
                        onChange={(e) => setInterest(e.target.value)}
                        required
                        style={{
                          background: "#ffffff",
                          borderRadius: "8px",
                          marginBottom: "30px",
                        }}
                      >
                        <option value="">Area of Interest</option>
                        <option value="Infrastructure">Infrastructure</option>
                        <option value="Grids">Grids</option>
                        <option value="Mobility">Industry</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Control
                        type="email"
                        placeholder="Enter email address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        style={{
                          background: "#ffffff",
                          borderRadius: "8px",
                          marginBottom: "30px",
                        }}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Name of the organization"
                        value={company}
                        onChange={(e) => setCompany(e.target.value)}
                        required
                        style={{
                          background: "#ffffff",
                          borderRadius: "8px",
                          marginBottom: "30px",
                        }}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Select
                        value={jobprofile}
                        onChange={(e) => setJobProfile(e.target.value)}
                        style={{
                          background: "#ffffff",
                          borderRadius: "8px",
                          marginBottom: "30px",
                        }}
                      >
                        <option value="">Job Profile</option>
                        <option value="Corporate">Corporate</option>
                        <option value="Engineering">Engineering</option>
                        <option value="Facility Management">
                          Facility Management
                        </option>
                        <option value="HR">HR</option>
                        <option value="Investor Relations / Analyst">
                          Investor Relations / Analyst
                        </option>
                        <option value="IT">IT</option>
                        <option value="Legal / Finance">Legal / Finance</option>
                        <option value="Marketing">Marketing</option>
                        <option value="Operations / Maintenance">
                          Operations / Maintenance
                        </option>
                        <option value="Other">Other</option>
                        <option value="Press / Journalist">
                          Press / Journalist
                        </option>
                        <option value="Procurement">
                          Procurement / Purchasing
                        </option>
                        <option value="Production">Production</option>
                        <option value="Project Management">
                          Project Management
                        </option>
                        <option value="Sales">Sales</option>
                        <option value="Student">Student</option>
                      </Form.Select>
                    </Form.Group>*/}
                  </Col>
                </Row>
                <div className="text-center mt-3">
                  <Button type="submit" className="register-button">
                    Register
                  </Button>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Error Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Registration Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="danger">{errorMessage}</Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Register;
